import { render } from "./KingOfTime.vue?vue&type=template&id=1fd34248&scoped=true"
import script from "./KingOfTime.vue?vue&type=script&lang=js"
export * from "./KingOfTime.vue?vue&type=script&lang=js"

import "./KingOfTime.vue?vue&type=style&index=0&id=1fd34248&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd34248"]])

export default __exports__